import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

const ProtectedPage = ({ children, isLoggedIn, admin }) => {
    const location = useLocation();

    if (!isLoggedIn) {
        return <Navigate to="/login" />;
    }

    // Role-based authorization check
    const isSuperAdmin = admin?.Role?.name?.toLowerCase() === 'super admin' || admin?.RoleId === 1;
    if (!isSuperAdmin) {
        let permissions = [];
        try {
            if (admin?.Role?.permissions) {
                permissions = typeof admin.Role.permissions === 'string'
                    ? JSON.parse(admin.Role.permissions)
                    : admin.Role.permissions;
            }
        } catch (e) {
            console.error("Error parsing permissions:", e);
        }
        const isAccountant = admin?.Role?.name?.toLowerCase() === 'accountant';
        const isInventoryManager = admin?.Role?.name?.toLowerCase()?.includes('inventory');
        const currentPath = location.pathname;

        const routePermissions = {
            '/': () => (permissions[0]?.view || isAccountant) && !isInventoryManager,
            '/faq': () => permissions[5]?.view && !isInventoryManager,
            '/page': () => permissions[6]?.view && !isInventoryManager,
            '/role': () => permissions[7]?.view && !isInventoryManager,
            '/sub-admin': () => permissions[4]?.view && !isInventoryManager,
            '/affiliate': () => permissions[3]?.view && !isInventoryManager,
            '/withdrawal': () => (permissions[3]?.view || isAccountant) && !isInventoryManager,
            '/order': () => (permissions[8]?.view || isAccountant || permissions[3]?.view) && !isInventoryManager,
            '/user': () => permissions[2]?.view && !isInventoryManager,
            '/category': () => permissions[10]?.view && !isInventoryManager,
            '/product': () => permissions[9]?.view && !isInventoryManager,
            '/reviews': () => permissions[9]?.view && !isInventoryManager,
            '/distributor': () => (permissions[9]?.view || isInventoryManager),
            '/inventory': () => (permissions[9]?.view || isInventoryManager),
            '/contact-us': () => permissions[1]?.view && !isInventoryManager,
            '/expense': () => isAccountant && !isInventoryManager,
            '/bank-setting': () => false, // Bank settings only for Super Admin
            '/limit-requests': () => false, // Only for Super Admin
            '/affiliate-rewards': () => permissions[3]?.view && !isInventoryManager, // Super Admin & Affiliate Manager
        };

        const matchedRoute = Object.keys(routePermissions).find(route => 
            currentPath === route || (route !== '/' && currentPath.startsWith(route + '/'))
        );

        if (matchedRoute) {
            const hasAccess = routePermissions[matchedRoute]();
            if (!hasAccess) {
                // Find fallback route based on permissions
                if (isInventoryManager) {
                    return <Navigate to="/inventory" replace />;
                } else if (permissions[3]?.view) {
                    return <Navigate to="/affiliate" replace />;
                } else if (isAccountant) {
                    return <Navigate to="/withdrawal" replace />;
                } else if (permissions[8]?.view) {
                    return <Navigate to="/order" replace />;
                } else {
                    if (currentPath !== '/profile-setting' && currentPath !== '/update-password') {
                        return <Navigate to="/profile-setting" replace />;
                    }
                }
            }
        }
    }

    return children;
}

const mapStateToProps = state => ({
    isLoggedIn: state.adminPage.isLoggedIn,
    admin: state.adminPage.loggedAdmin
});

export const ProtectedRoute = connect(mapStateToProps, {})(ProtectedPage);